module.exports = __webpack_public_path__ + "img/New Mexico outline.8512267b.png";